import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  signal,
  TemplateRef
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { ScrollableWrapperComponent } from '../scrollable-wrapper/scrollable-wrapper.component';
import { BaseComponent } from '../../../core/layout/components/abstracts/base.component';

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [
    NgTemplateOutlet,
    ScrollableWrapperComponent
  ],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalComponent extends BaseComponent{

  @ContentChild(TemplateRef) modalContent: TemplateRef<HTMLElement>;

  @Input() title: string;
  @Input() textAfterTitle: string;
  @Input() maxWidth: string;
  @Input() minWidth: string;
  @Input() width = '100%';
  @Input() showBackButton = false;
  @Input() height: string;
  @Input() compact = false;
  @Input() aspectRatio: string;
  @Input() alwaysRender = false

  @Output() closed = new EventEmitter<void>();
  @Output() backButtonClick = new EventEmitter<void>();

  public isOpened = signal(false);

  public open(): void {
    this.isOpened.set(true);
  }

  public close(): void {
    this.isOpened.set(false);
    this.closed.emit();
  }
}
